var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11424 1.70266C8.66354 1.70266 8.13772 1.7277 7.53678 1.82786C4.23161 2.35368 2.50391 4.75743 2.15336 7.33646C2.95462 6.3349 4.23161 5.53365 5.93427 5.53365C8.68858 5.53365 10.6166 7.51174 10.6166 10.5415C10.6166 13.3709 8.68858 16 5.45853 16C2.1784 16 0 13.421 0 9.38967C0 6.35994 1.07668 3.93114 2.62911 2.40376C3.9061 1.12676 5.6338 0.350548 7.58685 0.100157C8.18779 0.0250391 8.71362 0 9.0892 0L9.11424 1.70266ZM8.5133 10.6667C8.5133 8.43818 7.23631 7.11111 5.33333 7.11111C4.05634 7.11111 2.8795 7.88732 2.3036 9.01408C2.1784 9.26448 2.07825 9.56495 2.07825 9.94053C2.10329 12.4945 3.28013 14.3975 5.48357 14.3975C7.28639 14.3725 8.5133 12.8701 8.5133 10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.bffec9267fed9fbc718261bff3cc6dfe.svg";
export { ForwardRef as ReactComponent };